import React from "react";
import { Box, Button, Typography } from "@mui/material";
import useWindowSize from "../../hooks/useWindowSize";

const ThemePreview = ({ themeColor, onSaveTheme, themeId }) => {
  const { width } = useWindowSize();
  return (
    <Box
      sx={{
        // Light background color
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 3,
        width: "100%",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontWeight: 700,
          color: "#000",
          marginBottom: 2,
          fontSize: width > 900 ? "24px" : "16px",
        }}
      >
        Theme Preview
      </Typography>

      {/* Background Section */}
      <Box sx={{ textAlign: "left", width: "100%", maxWidth: "400px" }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 700,
            color: themeColor,
            marginBottom: 1,
          }}
        >
          Background
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "60px",
            backgroundColor: themeColor,
            borderRadius: "10px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        />
      </Box>

      {/* Buttons */}
      <Box
        sx={{ textAlign: "center", width: "100%", maxWidth: "400px", mt: 3 }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: themeColor,
            color: "#FFF",
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            width: "100%",
            height: "40px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          Button
        </Button>
        <Button
          variant="outlined"
          sx={{
            borderColor: themeColor,
            color: themeColor,
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            width: "100%",
            height: "40px",
            mt: 2,
          }}
        >
          Button
        </Button>
      </Box>

      {/* Text Elements */}
      <Box
        sx={{
          textAlign: "left",
          width: "100%",
          maxWidth: "400px",
          marginTop: 4,
        }}
      >
        {[...Array(3)].map((_, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fonstSize: index === 0 ? "26px" : index === 1 ? "20px" : "16px",
                color: themeColor,
              }}
            >
              H{index + 1}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: themeColor,
                fonstSize: index === 0 ? "26px" : index === 1 ? "20px" : "16px",
                fontWeight: 700,
              }}
            >
              Landings Page
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Apply and Cancel Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "400px",
          mt: 4,
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            color: "#FFF",
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            width: "45%",
            height: "40px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
          onClick={() =>
            onSaveTheme({
              themeName: themeColor,
              primaryColor: themeColor,
              themeId: themeId,
            })
          }
        >
          Apply
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#1976d2",
            color: "#FFF",
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            width: "45%",
            height: "40px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ThemePreview;
